import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchClassrooms(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/classrooms', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchClassroom(ctx, { id }) {
            return new  Promise((resolve, reject) => {
                axios
                    .get(`/classrooms/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createClassroom(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/classrooms/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error)) 
            })
        },
        addClassroom(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/classrooms', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteClassroom(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/classrooms/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateClassroom(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/classrooms/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error)) 
            })
        },

    }
}